module.exports = __webpack_public_path__ + "static/media/dentira.b76261b8.svg";